import { _t } from 'app/utils/i18n';
import { path } from 'app/utils/path';
import { apiRoutes } from 'hashtags/utils/apiRoutes';
import { BreadCrumbT, TrendingStateModuleNameT } from './types';

const pages = [
  { title: _t('hashtags:hashtags'), path: path.hashtags.DASHBOARD },
  { title: _t('hashtags:hashtags_table'), path: path.hashtags.HASHTAGS },
];
export const groupsPages = (isInfluencerModule: boolean): any => [
  {
    title: _t('basic:groups'),
    path: isInfluencerModule
      ? path.influencers.INFLUENCERS_GROUP
      : path.entities.ENTITIES_GROUP,
  },
  {
    title: _t('influencers:trending_hash_group'),
  },
];
export const categoriesPages = (isInfluencerModule: boolean): any => [
  {
    title: _t('basic:categories'),
    path: isInfluencerModule
      ? path.influencers.INFLUENCERS_CATEGORIES
      : path.entities.ENTITIES_CATEGORIES,
  },
  {
    title: _t('influencers:trending_hash_category'),
  },
];
export const handleCurrentPageBreadCrumb = (
  currentModule: string,
  isInfluencerModule: boolean
): BreadCrumbT => {
  const isRootModuleInfuencerOrEntity = {
    title: isInfluencerModule
      ? _t('influencers:influencers')
      : _t('entities:entities'),
    path: path[isInfluencerModule ? 'influencers' : 'entities'].ALL,
  };
  switch (currentModule) {
    case 'groups':
      return [
        isRootModuleInfuencerOrEntity,
        ...groupsPages(isInfluencerModule),
      ];
    case 'categories':
      return [
        isRootModuleInfuencerOrEntity,
        ...categoriesPages(isInfluencerModule),
      ];
    default:
      return pages;
  }
};
const trendsBreadCrumbPages = [
  {
    title: _t(`trends:trends`),
    path: path.trends.ALL,
  },
  {
    title: _t(`hashtags:hashtags_table`),
    path: path.trends.HASHTAGS,
  },
];
const hashtagsBreadcrumb = [
  {
    title: _t(`trends:hashtags`),
    path: path.hashtags.DASHBOARD,
  },
  {
    title: _t(`hashtags:hashtags_table`),
    path: path.hashtags.HASHTAGS,
  },
];

export const handleHashtagViewBreadCrumb = (currentModule: string): unknown => {
  const hashtagViewPage = {
    title: _t('trends:hashtag_view'),
  };
  switch (currentModule) {
    case 'categories':
      return [
        // ...categoriesPages,
        hashtagViewPage,
      ];
    case 'groups':
      return [
        // ...groupsPages,
        hashtagViewPage,
      ];
    case 'hashtags':
      return [...hashtagsBreadcrumb, hashtagViewPage];
    default:
      return [...trendsBreadCrumbPages, hashtagViewPage];
  }
};
export const handleTrendingModuleName = ({
  page,
  isInfluencerModule,
}: TrendingStateModuleNameT): string => {
  switch (page) {
    case 'groups':
      if (isInfluencerModule) return apiRoutes().influencersGroupsHashtags;
      else return apiRoutes().entitiesGroupsHashtags;
    case 'categories':
      if (isInfluencerModule) return apiRoutes().influencerCategoriesHashtags;
      else return apiRoutes().entitiesCategoriesHashtags;
    default:
      return apiRoutes().trendingHashtags;
  }
};
export const sortArrayFromRecentToOlder = (
  arr: [],
  ketExtractor: string
): [] => {
  if (!Array.isArray(arr)) return [];
  const newArr = arr.sort((a, b) => {
    const firstDate = new Date(a?.[ketExtractor]);
    const secondDate = new Date(b?.[ketExtractor]);
    return secondDate?.getTime() - firstDate?.getTime();
  });
  return newArr;
};
